import fs from 'fs';
import path from 'path';

import chalk from 'chalk';
import * as wikirefs from 'wikirefs';

import { MD } from '../util/const';
import type { InitTree } from '../util/tree';
import { getFileUris, resetGlobCache } from '../util/util';


function collectReferencedBasenames(): Set<string> {
  const refs: Set<string> = new Set();
  const paths: string[] = getFileUris();
  for (const mdPath of paths) {
    const content: string = fs.readFileSync(mdPath, 'utf8');
    const { filenames } = wikirefs.scan(content);
    for (const f of filenames) {
      refs.add(path.basename(f.filename.text, MD));
    }
  }
  return refs;
}

function classify(concept: string, referenced: Set<string>): 'known' | 'zombie' | 'missing' {
  const fp: string = path.join(process.cwd(), concept + MD);
  const hasFile: boolean = fs.existsSync(fp);
  const mentioned: boolean = referenced.has(concept);
  if (hasFile) {
    return 'known';
  }
  if (mentioned) {
    return 'zombie';
  }
  return 'missing';
}

function formatLine(concept: string, kind: 'known' | 'zombie' | 'missing'): string {
  if (kind === 'known') {
    return `✅ ${concept}`;
  }
  if (kind === 'zombie') {
    return `🧟 ${concept}`;
  }
  return `❌ ${concept}`;
}

export function check(concepts: string[], _payload: InitTree, _argv?: any): void {
  resetGlobCache();
  const referenced: Set<string> = collectReferencedBasenames();
  const list: string[] = concepts ?? [];
  const trimmed: string[] = list.map((c) => c.trim()).filter((c) => c.length > 0);
  if (trimmed.length === 0) {
    console.log(chalk.dim('--'));
    return;
  }
  const lines: string[] = [chalk.dim('✅ file  🧟 zombie link  ❌ void'), ''];
  for (const concept of trimmed) {
    const kind: 'known' | 'zombie' | 'missing' = classify(concept, referenced);
    lines.push(formatLine(concept, kind));
  }
  console.log(lines.join('\n'));
}
